<template>
  <main>
    <section id="parallax" class="section--full section--banner" @mousemove="parallax">
      <video autoplay muted loop class="section__video">
        <source src="@/assets/video/motiontech.mp4" type="video/mp4">
      </video>
    </section>
    <section class="container container--short">
      <div class="container--white">
        <h2 class="heading-detail">MotionTech Launch</h2>
        <br>
        <p class="description">
         Motion Technology (MotionTech) menghadirkan lingkungan kerja yang dinamis, efisien, nyaman, dengan dilengkapi fasilitas teknologi terkini. MotionTech menjadi wadah bagi unit MNC Financial Services sebagai ekosistem jasa keuangan digital paling terintegrasi di Indonesia. Kehadiran MotionTech merupakan bagian penting dari rencana strategi digital MNC Group untuk masa depan.
        </p>
        <br>
        <p class="description">
          Motion Technology mengusung konsep yang mengintegrasikan berbagai aplikasi fintech MNC Financial Services, seperti MotionBanking, MotionPay, MotionInsure, MotionTrade dan aplikasi Motion lain yang sedang dikembangkan.
        </p>
        <br>
        <p class="description">
          Langkah tersebut adalah sebagai komitmen MNC Financial Services untuk menciptakan ekosistem financial technology (fintech) end-to-end yang menempatkan kenyamanan pengguna di setiap langkah perjalanan inovasinya.
        </p>

        <div class="details">
          <img class="md-image" src="@/assets/images/motiontech.png" alt="">
        </div>

        <!-- <div class="details">
          <table class="description">
            <thead>
                <tr>
                  <th colspan="4">
                  <span class="txt-bold"> Agenda Peresmian MotionTech <br> MNC Financial Center 5th Fl.</span><br> Selasa, 2 November 2021
                  </th>
                </tr>
                <tr>
                  <th>Start</th>
                  <th>End</th>
                  <th>AKTIVITAS</th>
                </tr>
            </thead>
            <tbody>
                <tr>
                    <th>11:00</th>
                    <td>11:01</td>
                    <td>Pembukaan oleh MC</td>
                </tr>
                <tr>
                    <th>11:01</th>
                    <td>11:03</td>
                    <td>Prosesi Peresmian MotionTech</td>
                </tr>
                <tr>
                  <th>11:03</th>
                  <td>11:05</td>
                  <td>Video Opening</td>
                </tr>
                <tr>
                  <th>11:05</th>
                  <td>11:10</td>
                  <td>MotionTech Introduction & Road Map</td>
                </tr>
                <tr>
                  <th>11:10</th>
                  <td>11:20</td>
                  <td>Sambutan Executive Chairman MNC Group</td>
                </tr>
                <tr>
                  <th>11:20</th>
                  <td>11:22</td>
                  <td>Pembacaan Doa</td>
                </tr>
                <tr>
                  <th>11:22</th>
                  <td>11:25</td>
                  <td>
                    <span>Pemotongan Tumpeng Syukuran:</span>
                    <ol class="mg-left-35">
                      <li class="description list-block">Peresmian MotionTech</li>
                      <li class="description list-block">HUT MNC Group yang ke-32 tahun</li>
                    </ol>
                  </td>
                </tr>
                <tr>
                  <th>11:25</th>
                  <td>11:45</td>
                  <td>
                    <span>Vlog Tour MotionTech Facility:</span>
                    <ol class="mg-left-35">
                      <li class="description list-block txt-bold">Co-working area</li>
                      <li class="description list-block txt-bold">SOC Room</li>
                      <li class="description list-block txt-bold">DAC Room</li>
                      <li class="description list-block txt-bold">Conference Room</li>
                    </ol>
                  </td>
                </tr>
                <tr>
                  <th>11:45</th>
                  <td>11:46</td>
                  <td>Penutupan oleh MC</td>
                </tr>
                <tr>
                  <th>11:46</th>
                  <td>12:00</td>
                  <td>Media Doorstop</td>
                </tr>
                <tr>
                  <th>12:00</th>
                  <td>12:30</td>
                  <td>Performance by Innoband & Santap Siang</td>
                </tr>
            </tbody>
          </table>
        </div> -->
      </div>
    </section>
  </main>
</template>

<script>
import parallax from '@/commons/parallax.js'

export default {
  name: 'DetailMotion',
  methods: {
    parallax(e) {
      const elem = document.querySelector("#parallax > video")

      elem.style.top = parallax.parallaxAnimation(e).vidY;
      elem.style.left = parallax.parallaxAnimation(e).vidX;
    
    }
  }
}
</script>